module.exports = require("./lib/_stream_passthrough.js")



//////////////////
// WEBPACK FOOTER
// ../~/readable-stream/passthrough.js
// module id = 141
// module chunks = 0